import { SWRFetcher } from '@commenda/utils';
import useSWR from 'swr';
import { RootfiCashFlowStatement, StatementFilters } from './types';

interface CashFlowStatementResponse {
  periods: RootfiCashFlowStatement[];
  periodStart: string;
  periodEnd: string;
}

export function useCashFlowStatement(
  corporationId: number | null,
  filters?: StatementFilters
) {
  const params = new URLSearchParams({ corporationId: String(corporationId) });
  if (filters?.periodStart) params.set('periodStart', filters.periodStart);
  if (filters?.periodEnd) params.set('periodEnd', filters.periodEnd);
  if (filters?.period) params.set('period', String(filters.period));

  const { data, error, isLoading } = useSWR<CashFlowStatementResponse>(
    corporationId ? `rootfi/cash-flow-statement?${params.toString()}` : null,
    SWRFetcher({ method: 'GET' })
  );

  return {
    periods: data?.periods ?? [],
    periodStart: data?.periodStart,
    periodEnd: data?.periodEnd,
    isLoading,
    error,
  };
}
